import React from 'react';

import ErrorDisplay from '@/components/videos/ErrorDisplay';
import ProgressBar from '@/components/videos/ProgressBar';
import useApproximateProgress from '@/hooks/useApproximateProgress';
import { Image } from '@/components/Image';
import { PersonalAvatarStatus } from '@/api/personal-avatars';
import { PersonalAvatarViewData } from '@/api/personal-avatars';

interface PersonalAvatarCardContentProps {
  avatar: PersonalAvatarViewData;
}

export const PersonalAvatarCardContent: React.FC<PersonalAvatarCardContentProps> = ({ avatar }) => {
  const progress = useApproximateProgress(60, avatar.createdAt);

  if (avatar.status === PersonalAvatarStatus.FAILED) {
    return <ErrorDisplay message="Generation failed" />;
  }

  if (avatar.status === PersonalAvatarStatus.PROCESSING) {
    return <ProgressBar progress={progress} />;
  }

  const renderMedia = () => {
    return (
      <Image src={avatar.avatarImage?.posterUrl || ''} alt={avatar.name} fill objectFit="cover" fetchPriority="high" />
    );
  };

  return <div className="relative h-full w-full">{renderMedia()}</div>;
};
